import React from 'react'
import styled from 'styled-components'
import { ISelectablePlan } from '../interfaces/plan'
// import { ComparePlans } from './ComparePlansModal'
import PlanInformation from './PlanInformation'
import { Resource } from './Resource'
// import { ComparePlans } from './ComparePlansModal'

const PlanListWrapper = styled.div`
  width: 100%;
  padding: 33px 27px;
  margin-bottom: 24px;
`

const PlanListHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 40px;
  margin-bottom: 1rem;
`

const HighlightLabel = styled.span`
  font-family: 'Sentinel';
  color: var(--primary);
  font-size: 22px;
`

const NormalLabel = styled.span`
  font-size: 22px;
  font-weight: 500;
`

const Plans = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 auto;
  @media (min-width: 1024px) {
    flex-direction: row;
  }
  max-width: 1000px;
`

const ResourceWrapper = styled.div`
  width: 313px;
  height: 87px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  margin-right: 19px;

  @media (max-width: 1024px) {
    margin-bottom: 2rem;
  }
`

export interface PlanListProps {
  plans: ISelectablePlan[]
  onPlanSelect: (selected: boolean, id: string) => void
  nonSelectedOpacity?: number
  onShowPlanDetails: (id: string, plan: any) => void
}

export const PlanList: React.FC<PlanListProps> = ({
  plans,
  onPlanSelect,
  onShowPlanDetails,
  nonSelectedOpacity = 1
}) => {
  // const selectedPlans = plans.filter((plan) => plan.selected)

  return (
    <PlanListWrapper>
      {/*       <PlanListHeader>
        <HighlightLabel>{selectedPlans.length} plans selected</HighlightLabel>
      </PlanListHeader> */}
      <Plans>
        {plans.map((plan: ISelectablePlan) => (
          <PlanInformation
            plan={plan}
            key={plan.id}
            onPlanSelect={onPlanSelect}
            onShowPlanDetails={onShowPlanDetails}
            nonSelectedOpacity={nonSelectedOpacity}
          />
        ))}
      </Plans>
    </PlanListWrapper>
  )
}

export const OtherCarrier = () => {
  return (
    <PlanListWrapper>
      <PlanListHeader>
        <div>
          <HighlightLabel>Carrier:</HighlightLabel>
          <NormalLabel> No Additional Results</NormalLabel>
        </div>
      </PlanListHeader>
      <ResourceWrapper className="w-100">
        <Resource
          whiteBg
          title="Looking for additional plans? Reach out to your enrollment specialist"
          icon="icon-question-mark"
          className="w-100 h-100 m-0"
        />
      </ResourceWrapper>
    </PlanListWrapper>
  )
}

export default PlanList
